<template>
  <div>
    <div class="deleted_license_keys" v-if="deletedKeys.length > 0">
      <div class="license_title" @click="toggleExpand">
        <i class="icon-license"></i>
        {{ $t('dashboard.deletedLicenseKeys') }}
        <span class="key_count">({{ deletedKeys.length }})</span>
        <i class="expand_icon" :class="{ expanded: isExpanded }">▼</i>
      </div>
      <div class="license_info" v-show="isExpanded">
        <ul class="license_list">
          <li v-for="key in deletedKeys" :key="key" class="license_item deleted">
            <p>
              {{ $t('dashboard.licenseKey') }} <span>{{ key }}</span>
            </p>
            <p class="deleted_label">
              <span>{{ lang === 'en' ? 'Deleted' : '已删除' }}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DeletedLicenseKeys',
    props: {
      deletedKeys: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        isExpanded: false
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      toggleExpand() {
        this.isExpanded = !this.isExpanded
      }
    }
  }
</script>

<style lang="scss" scoped>
  .deleted_license_keys {
    height: 100%;
    background: $white;
    @include border-radius(6px);
    padding: 25px 23px 14px;
    font-size: 18px;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 13px;
    border: $border;
    @include box-shadow;
    
    .license_title {
      height: 18px;
      font-family: NexaBold;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      user-select: none;
      transition: opacity 0.2s;
      
      &:hover {
        opacity: 0.8;
      }
      
      .icon-license {
        font-size: 16px;
      }
      
      .key_count {
        font-size: 14px;
        font-weight: normal;
        color: #999;
        margin-left: 4px;
      }
      
      .expand_icon {
        margin-left: auto;
        font-size: 12px;
        color: #666;
        transition: transform 0.3s ease;
        
        &.expanded {
          transform: rotate(180deg);
        }
      }
    }
    
    .license_info {
      height: 100%;
      border: $border;
      @include border-radius(6px);
      margin-top: 20px;
      font-size: 14px;
      padding: 10px 20px;
      color: #777;
      position: relative;
      animation: slideDown 0.3s ease;
      
      & p {
        display: flex;
        span {
          color: #42434b;
          margin-left: 5px;
        }
      }
      
      .license_list {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      
      .license_item {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 80%;
        padding: 8px;
        border-radius: 8px;
        border: 1px solid #d1d4d9;
        
        &.deleted {
          opacity: 0.6;
          background-color: #f5f5f5;
        }
        
        .deleted_label {
          margin-top: 4px;
          span {
            color: #f56c6c;
            font-weight: bold;
          }
        }
      }
    }
  }
  
  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 1000px;
    }
  }
  
  @media screen and (max-width: 760px) {
    .deleted_license_keys {
      height: auto;
      box-shadow: none;
      font-size: 14px;
      
      .license_info {
        height: auto;
        
        .license_item {
          width: auto;
        }
        
        & p {
          display: block;
          margin-top: 10px;
          & span {
            display: block;
            width: 90%;
            overflow: visible;
            white-space: normal;
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/DeletedLicenseKeys.vue